import * as React from 'react'; 

import { HomePhoto } from '../'

import { PhotoData } from '@App/common/data/photoData'
import { PhotoListModel, PhotoModel } from '@App/common/models'

import './home.css'

export interface IHomeContainerState{
  homePhotos: PhotoListModel;
}

export default class IHomeContainer extends React.PureComponent<any, IHomeContainerState> {
  // private maxTall = 768;
  
  constructor(props: any) {
    super(props);

    let homePhotoList: PhotoListModel = new PhotoListModel;
    for (const i of PhotoData) {
      if (i.category === 'home') {
        const hp:PhotoListModel = i;
        homePhotoList = hp;
      }
    }

    this.state = {
      homePhotos: homePhotoList,
    }
  }

  public getRandomInt = ():number => {
    const ar = window.innerWidth / window.innerHeight;
    // if (window.innerWidth < this.maxTall) {
    if (ar < 1) {
      return Math.floor(Math.random() * (2 - 0 + 1)) + 0;
    } else {
      return Math.floor(Math.random() * (5 - 1 + 1)) + 1;
    }
  }

  public getRandomPhoto = (): PhotoModel => {
    // const w = window.innerWidth;
      return this.state.homePhotos.photoList[this.getRandomInt()];
  }

  public render() {
    return (
      <div className='homephoto_div'>
        <HomePhoto photo={ this.getRandomPhoto() } />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/bundles/home/components/home/homeContainer.tsx